/**
 * A deterministic decorative waveform shared by every song until real peak
 * data is available. Values are normalized heights in the range 0..1.
 */
export const AUDIO_WAVEFORM_BARS = [
  0.22, 0.42, 0.68, 0.86, 0.58, 0.38, 0.72, 0.48, 0.78, 0.62, 0.34, 0.52, 0.74,
  0.44, 0.64, 0.88, 0.7, 0.4, 0.58, 0.46, 0.8, 0.92, 0.54, 0.38, 0.66, 0.5,
  0.72, 0.44, 0.84, 0.62, 0.36, 0.54, 0.76, 0.48, 0.68, 0.9, 0.6, 0.42, 0.74,
  0.52, 0.82, 0.64, 0.4, 0.56, 0.7, 0.46, 0.78, 0.58, 0.34, 0.66, 0.86, 0.5,
  0.72, 0.42, 0.62, 0.8,
] as const;

export const AUDIO_WAVEFORM_HEIGHT = 20;
export const AUDIO_WAVEFORM_GAP = 2.5;
export const AUDIO_WAVEFORM_BAR_RADIUS = 999;

export function clampAudioWaveformProgress(progress: number): number {
  if (!Number.isFinite(progress)) return 0;
  return Math.min(Math.max(progress, 0), 1);
}

export function getAudioWaveformBarProgress(
  progress: number,
  index: number,
  barCount = AUDIO_WAVEFORM_BARS.length,
): number {
  return clampAudioWaveformProgress(progress * barCount - index);
}
